export default __webpack_public_path__ + "static/media/spr-schema-2-light-large.10457561.png";